import TakeHomeLowerBodyQuestions from './take-home-lower-body-questions';

export default TakeHomeLowerBodyQuestions;
